import { FileType, GoogleFileType, emptyValidationResponse, GOOGLE_EMBED_ENDING } from '../urlValidationUtils'

const GoogleValidator = (url: string) => {
  let regexGroups

  // First attempt (Docs, Sheets, Slides)
  regexGroups = /(?:https:\/\/)?(?:www.)?docs.google.com\/([\w\-_]+)\/*\/d\/e\/([\w\-_]+)\/([\w\-_?=&;]+)/.exec(url)
  let googleFileType = regexGroups?.[1] ? (regexGroups[1] as GoogleFileType) : undefined

  if (googleFileType)
    return {
      validUrl: `https://docs.google.com/${googleFileType}/d/e/${regexGroups?.[2]}/${GOOGLE_EMBED_ENDING[googleFileType]}`,
      isEmbeddable: true,
      newFileType:
        googleFileType && Object.values(FileType).includes(googleFileType) ? googleFileType : FileType.DOCUMENT,
    }

  // Second Attempt (Drive)
  regexGroups =
    /(?:https:\/\/)?(?:www.)?drive.google.com\/([\w\-_]+)\/*\/d\/?([\w\-_]+)\/(?:view|preview)\??([\w\-_?=&;]+)?/.exec(
      url,
    )
  if (regexGroups?.[0]) {
    const validUrl = new URL(
      `https://drive.google.com/file/d/${regexGroups[2]}/${GOOGLE_EMBED_ENDING[FileType.FILE]}?${
        regexGroups[3] ? regexGroups[3] : ''
      }`,
    )

    // For Google Drive files, the embeddable link yields 'resourceKey' with uppercase 'K', but iframely can only handle it in lowercase
    const resourceKey = validUrl.searchParams.get('resourceKey')
    if (resourceKey) {
      validUrl.searchParams.set('resourcekey', resourceKey)
      validUrl.searchParams.delete('resourceKey')
    }

    return {
      validUrl: validUrl.href,
      isEmbeddable: true,
      newFileType: FileType.FILE,
    }
  }

  // No second attempt, setting Google file type (Doc, Sheet or Slide)
  regexGroups = /(?:https:\/\/)?(?:www.)?(?:drive|docs)\.google.com\/([\w\-_]+)\/*/.exec(url)
  googleFileType = regexGroups?.[1] ? (regexGroups[1] as GoogleFileType) : undefined
  return {
    ...emptyValidationResponse,
    newFileType:
      googleFileType && Object.values(FileType).includes(googleFileType) ? googleFileType : FileType.DOCUMENT,
  }
}

export default GoogleValidator
